//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapActions, mapGetters } from 'vuex';
import SwitchButton from '~/components/SwitchButton';
import PersonalCard from '~/components/Card/PersonalCard';
import ResumeBasic from './ResumeBasic.vue';
import Education from './Education.vue';
import WorkExperience from './WorkExperience.vue';
import Skill from './Skill.vue';
import Language from './Language.vue';
import { sortByDate } from '~/utils';

export default {
  name: 'Jobs',
  components: {
    SwitchButton,
    PersonalCard,
    ResumeBasic,
    Education,
    WorkExperience,
    Skill,
    Language,
  },
  computed: {
    ...mapGetters('user', ['token']),
  },
  methods: {
    ...mapActions('personal', ['setResumeData', 'setIsEdit']),
    getUserResume() {
      if (this.token) {
        this.$api('userGetUserResume')
          .then(data => {
            var resume = Object.assign({}, data);
            if (resume.acceptableAbroad) {
              resume.acceptableCountryName =
                '是，可接受國家：' +
                resume.acceptableCountry
                  .map(c => {
                    return c.areaName;
                  })
                  .join(',');
              resume.acceptableCountry = resume.acceptableCountry.map(c => {
                return c.areaId;
              });
            } else {
              resume.acceptableCountryName = '否';
            }
            resume.acceptableInTaiwanName = resume.acceptableInTaiwan
              .map(c => {
                return c.areaName;
              })
              .join(',');
            resume.acceptableInTaiwan = resume.acceptableInTaiwan.map(c => {
              return c.areaId;
            });
            resume.jobCatIds = resume.userJobCatList.map(c => {
              return c.jobCatId;
            });

            resume.userEducationList = sortByDate(resume.userEducationList);
            resume.userExperienceList = sortByDate(resume.userExperienceList);

            this.setResumeData(resume);
            this.setIsEdit(false);
          })
          .catch(e => {
            setTimeout(() => {
              this.getUserInfo();
            }, 500);
          });
      }
    },
  },
  mounted() {
    if (process.client && this.token) {
      this.getUserResume();
    }
  },
};
